<div class="modal-header">
  @if (itemResponseModel != null) {
    <h4 class="modal-title">View item {{itemResponseModel.itemDetails.itemId}}</h4>
  }
</div>
<div class="modal-body">
  <div>
    <fieldset class="border p-2" style="margin-top: 10px;">
      <legend class="float-none w-auto legend-style"><span style="margin-left: 5px; margin-right: 5px;">Item details</span></legend>

      @if (itemResponseModel != null) {
        <div>
          <!-- Basic Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Item ID:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.itemId}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Description:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.description | enGbText}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Detailed description:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.detailedDescription | enGbText}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Base UOM code:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.baseUOMCode}}</label>
            </div>
          </div>
          <!-- Source Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Origin source:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.origin?.originSource}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Publishing source:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.origin?.publishingSource}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>ALSIS product code:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.alsisProductCode}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>ALSIS scope:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.alsisScope}}</label>
            </div>
          </div>
          <!-- Classification & State -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Item classification:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.classification?.itemClassification}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Item classification description:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.classification?.itemClassificationDescription}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Item state:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.status.itemState}} ({{utilService.getItemStateDescription(itemResponseModel.status.itemState, itemResponseModel.status.itemStateDescription)}})</label>
            </div>
            <div class="col-sm-3">
              <label><b>Lifecycle management status:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.status.lifecycleManagementStatus}} ({{itemResponseModel.status.lifecycleManagementStatusDescription}})</label>
            </div>
          </div>
          <!-- Item Properties -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Taxonomy node ID:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.classification?.taxonomyNodeId}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Taxonomy node name:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.classification?.taxonomyNodeName}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Alternate item ID:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.alternateItemId}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Original source publish time:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.origin?.originalSourcePublishTime}}</label>
            </div>
          </div>
          <!-- Boolean Flags -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Is spare part:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.isSparePart ? 'Yes' : 'No'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Current item ID:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.currentItemId}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Is customer unique:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.isCustomerUnique ? 'Yes' : 'No'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Is AlfaLaval item:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.isAlfaLavalItem ? 'Yes' : 'No'}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Is sales item:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.isSalesItem ? 'Yes' : 'No'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Is configured:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.isConfigured ? 'Yes' : 'No'}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Is commercial product item:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.isCommercialProductItem ? 'Yes' : 'No'}}</label>
            </div>
          </div>
          <!-- Arrays -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Alternate items:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.alternateItems?.join(', ') || 'None'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Supersedes:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supersedesFromHistory.length > 0 ? supersedesFromHistory.join(', ') : 'None'}}</label>
            </div>
          </div>
          <!-- Deletion Information -->
          @if (itemResponseModel.status.isMarkedForDeletion) {
            <div class="row mb5">
              <div class="col-sm-3">
                <label><b>Is marked for deletion:</b></label>
              </div>
              <div class="col-sm-3">
                <label>{{itemResponseModel.status.isMarkedForDeletion ? 'Yes' : 'No'}}</label>
              </div>
              <div class="col-sm-3">
                <label><b>Marked for deletion date:</b></label>
              </div>
              <div class="col-sm-3">
                <label>{{itemResponseModel.status.markedForDeletionDateTime}}</label>
              </div>
            </div>
          }
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Revision ID:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.revisionId}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Configuration ID:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.configurationId}}</label>
            </div>           
          </div>
          <!-- Date Time Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Item created date:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.timestamps?.itemCreatedDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Last modification date:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.timestamps?.lastModificationDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Created date:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.timestamps?.createdDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Update date:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.timestamps?.updateDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Replaced by:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{replacedBy || 'None'}}</label>
            </div>
             <div class="col-sm-3">
              <label><b>Configurator source:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{itemResponseModel.itemDetails.configuratorSource}}</label>
            </div>
          </div>
        </div>
      }


    </fieldset>

    <div class="mt-2">
      <ul ngbNav #nav="ngbNav" [(activeId)]="tabModel.activeTab" class="nav-tabs">
        <li [ngbNavItem]="1">
          <a ngbNavLink (click)="onclickGoToTab(1)">Suppliers</a>
          <ng-template ngbNavContent>
            <div>
              @if (suppliersLoading) {
                <div class="d-flex align-items-center gap-2 py-2 ps-2">
                  <div class="spinner-border spinner-border-sm alfalaval-blue-color" role="status"></div>
                  <span>Loading suppliers...</span>
                </div>
              } @else if (suppliersError) {
                <div class="alert alert-danger py-1 px-2 my-1">{{ suppliersError }}</div>
              } @else {
                <kendo-grid
                  [data]="rowDefs"
                  [scrollable]="'none'">
                  <kendo-grid-column field="supplierDetails.supplierId" title="Supplier ID" [width]="120"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.isMainSupplier" title="Main Supplier" [width]="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ dataItem.supplierDetails?.isMainSupplier ? 'YES' : 'NO' }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.stockCode" title="Stock Code" [width]="100"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.legalEntity" title="Legal Entity" [width]="110"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.legalEntityName" title="Legal Entity Name"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.siteId" title="Site ID" [width]="80"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.baseUOMCode" title="Base UOM" [width]="90"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.supplierItemIdentification" title="Supplier Item ID" [width]="130"></kendo-grid-column>
                  <kendo-grid-column field="timestamps.lastModificationDateTime" title="Last Modified" [width]="160">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ dataItem.timestamps?.lastModificationDateTime | date: 'yyyy-MM-dd HH:mm:ss' }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="" [width]="55">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <button class="btn btn-outline-secondary btn-sm" (click)="viewSupplier(dataItem)" title="View supplier">
                        <i class="fa fa-magnifying-glass" aria-hidden="true"></i>
                      </button>
                    </ng-template>
                  </kendo-grid-column>
                </kendo-grid>
              }
            </div>
          </ng-template>
        </li>
          <li [ngbNavItem]="2">
            <a ngbNavLink (click)="onclickGoToTab(2)">History</a>
            <ng-template ngbNavContent>
              <div>
                @if (suppliersLoading) {
                  <div class="d-flex align-items-center gap-2 py-2 ps-2">
                    <div class="spinner-border spinner-border-sm alfalaval-blue-color" role="status"></div>
                    <span>Loading...</span>
                  </div>
                } @else {
                  <kendo-grid [data]="historyRowDefs" [scrollable]="'none'">
                    <kendo-grid-column field="itemId" title="Item ID" [width]="120"></kendo-grid-column>
                    <kendo-grid-column field="replacedByItemId" title="Replaced by Item ID" [width]="150"></kendo-grid-column>
                    <kendo-grid-column field="reason" title="Reason"></kendo-grid-column>
                    <kendo-grid-column field="reasonCode" title="Reason Code" [width]="110"></kendo-grid-column>
                    <kendo-grid-column field="isLatestChange" title="Is Latest Change" [width]="130">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.isLatestChange ? 'YES' : 'NO' }}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="eventDateTime" title="Event Date" [width]="160"></kendo-grid-column>
                    <kendo-grid-column field="createdDateTime" title="Created Date" [width]="160"></kendo-grid-column>
                  </kendo-grid>
                }
              </div>
            </ng-template>
          </li>
            <li [ngbNavItem]="3">
              <a ngbNavLink (click)="onclickGoToTab(3)">Value pairs</a>
              <ng-template ngbNavContent>
                <div>
                  @if (isAdmin) {
                    <button type="button" class="btn btn-outline-dark mb5" (click)="addNewItemProperty()">Add New Property</button>
                  }
                  @if (suppliersLoading) {
                    <div class="d-flex align-items-center gap-2 py-2 ps-2">
                      <div class="spinner-border spinner-border-sm alfalaval-blue-color" role="status"></div>
                      <span>Loading...</span>
                    </div>
                  } @else {
                    <kendo-grid [data]="itemPropertiesRowDefs" [scrollable]="'none'">
                      <kendo-grid-column field="key" title="Key"></kendo-grid-column>
                      <kendo-grid-column field="value" title="Value"></kendo-grid-column>
                      <kendo-grid-column field="type" title="Type" [width]="100"></kendo-grid-column>
                      <kendo-grid-column field="originSource" title="Origin Source" [width]="120"></kendo-grid-column>
                      <kendo-grid-column field="publishingSource" title="Publishing Source" [width]="140"></kendo-grid-column>
                      <kendo-grid-column field="taxonomyNodeId" title="Taxonomy Node ID" [width]="140"></kendo-grid-column>
                      <kendo-grid-column field="updateDateTime" title="Updated At" [width]="160"></kendo-grid-column>
                      @if (isAdmin) {
                        <kendo-grid-column title="" [width]="90">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <button class="btn btn-outline-secondary btn-sm me-1" (click)="editItemProperty(dataItem)" title="Edit">
                              <i class="fa fa-edit" aria-hidden="true"></i>
                            </button>
                            <button class="btn btn-outline-danger btn-sm" (click)="deleteItemProperty(dataItem)" title="Delete">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                            </button>
                          </ng-template>
                        </kendo-grid-column>
                      }
                    </kendo-grid>
                  }
                </div>
              </ng-template>
            </li>
              <li [ngbNavItem]="4">
                <a ngbNavLink (click)="onclickGoToTab(4)">Export control</a>
                <ng-template ngbNavContent>
                  <div>
                    @if (exportControlLoading) {
                      <div class="d-flex align-items-center gap-2 py-2 ps-2">
                        <div class="spinner-border spinner-border-sm alfalaval-blue-color" role="status"></div>
                        <span>Loading export control...</span>
                      </div>
                    } @else if (exportControlError) {
                      <div class="alert alert-danger py-1 px-2 my-1">{{ exportControlError }}</div>
                    } @else {
                      <kendo-grid [data]="exportControlRowDefs" [scrollable]="'none'">
                        <kendo-grid-column field="itemId" title="Item ID" [width]="120"></kendo-grid-column>
                        <kendo-grid-column field="type" title="Type" [width]="120"></kendo-grid-column>
                        <kendo-grid-column field="code" title="Code" [width]="120"></kendo-grid-column>
                        <kendo-grid-column field="regionCode" title="Region Code" [width]="120"></kendo-grid-column>
                      </kendo-grid>
                    }
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="5">
                <a ngbNavLink (click)="onclickGoToTab(5)">Persisted messages</a>
                <ng-template ngbNavContent>
                  <div>
                    @if (persistMessageReferencesLoading) {
                      <div class="d-flex align-items-center gap-2 py-2 ps-2">
                        <div class="spinner-border spinner-border-sm alfalaval-blue-color" role="status"></div>
                        <span>Loading message references...</span>
                      </div>
                    } @else if (persistMessageReferencesError) {
                      <div class="alert alert-danger py-1 px-2 my-1">{{ persistMessageReferencesError }}</div>
                    } @else {
                      <kendo-grid [data]="persistMessageReferencesRowDefs"
                                  [pageSize]="persistMessageReferencesPageSize"
                                  [skip]="persistMessageReferencesPageIndex"
                                  [pageable]="true"
                                  (pageChange)="onPersistMessageReferencesPageChange($event)"
                                  [scrollable]="'none'">
                        <ng-template kendoGridToolbarTemplate>
                          <button class="btn btn-outline-secondary btn-sm"
                                  [disabled]="!canCompareSelectedMessages"
                                  (click)="compareSelectedMessages()"
                                  title="Compare the two selected records">
                            <i class="fa fa-code-compare me-1" aria-hidden="true"></i>Compare selected
                          </button>
                          <span class="ms-2 text-muted small">Select exactly 2 records to compare</span>
                        </ng-template>
                        <kendo-grid-column title="" [width]="40">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <input type="checkbox"
                                   [checked]="isPersistMessageSelected(dataItem.id)"
                                   [disabled]="!isPersistMessageSelected(dataItem.id) && persistMessageSelectedIds.length >= 2"
                                   (change)="onPersistMessageCheckChange(dataItem.id, $any($event.target).checked)" />
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="itemId" title="Item ID" [width]="120"></kendo-grid-column>
                        <kendo-grid-column field="supplierId" title="Supplier ID" [width]="110"></kendo-grid-column>
                        <kendo-grid-column field="referenceId" title="Reference ID"></kendo-grid-column>
                        <kendo-grid-column field="createdDateTime" title="Created" [width]="160">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            {{ dataItem.createdDateTime | date: 'yyyy-MM-dd HH:mm:ss' }}
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="messageType" title="Message Type" [width]="130"></kendo-grid-column>
                        <kendo-grid-column field="source" title="Source" [width]="120"></kendo-grid-column>
                        <kendo-grid-column title="" [width]="55">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <button class="btn btn-outline-secondary btn-sm" (click)="viewMessageReference(dataItem)" title="View message">
                              <i class="fa fa-magnifying-glass" aria-hidden="true"></i>
                            </button>
                          </ng-template>
                        </kendo-grid-column>
                      </kendo-grid>
                    }
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="6">
                <a ngbNavLink (click)="onclickGoToTab(6)">Descriptions</a>
                <ng-template ngbNavContent>
                  <div>
                    <kendo-grid [data]="descriptionRowDefs" [scrollable]="'none'">
                      <kendo-grid-column field="languageCode" title="Language Code" [width]="140"></kendo-grid-column>
                      <kendo-grid-column field="description" title="Description"></kendo-grid-column>
                      <kendo-grid-column field="detailedDescription" title="Detailed Description"></kendo-grid-column>
                    </kendo-grid>
                  </div>
                </ng-template>
              </li>
              </ul>
              <div [ngbNavOutlet]="nav" class="mt-2"></div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-dark" (click)="close()">Close</button>
        </div>
